export const keepUnusedDataFor = 60 * 5;
export const bingxApiUri = process.env.NODE_ENV === 'development'
	? `${window.location.protocol}//${window.location.hostname}:3001`
	: "https://bingxapi.moisa.cloud";
export const binanceFuturesUri = "https://fapi.binance.com";
export const binanceSpotUri = "https://api.binance.com";
